import anime from 'animejs'
import clsx from 'clsx'
import { ElementType, Fragment } from 'react'
import { useInViewEffect } from 'react-hook-inview'

type Props = {
  id: string
  as?: ElementType
  content: string | string[]
  className?: string
  splittedClassNames?: string[]
  onStarted?: () => void
  onProgress?: (progress: number) => void
  onFinished?: () => void
}

const AnimatedText = ({
  as,
  id,
  content,
  className,
  splittedClassNames,
  onStarted,
  onProgress,
  onFinished,
}: Props) => {
  const Text = as || 'p'

  const ref = useInViewEffect(([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target)

      anime({
        targets: `#${id} .target-text`,
        translateY: [1000, 0],
        duration: 300,
        opacity: [0, 1],
        skewY: [50, 0],
        easing: 'spring(1, 80, 15, 0)',
        delay: anime.stagger(50),
        begin: () => {
          if (onStarted) {
            onStarted()
          }
        },
        update: anim => {
          if (onProgress) {
            onProgress(anim.progress)
          }
        },
        complete: () => {
          if (onFinished) {
            onFinished()
          }
        },
      })
    }
  })

  return (
    <div ref={ref} id={id}>
      <Text className={clsx('', className)}>
        {typeof content === 'string'
          ? content.split(' ').map((word, index) => (
              <span
                key={index}
                className="mr-[0.5ch] inline-flex overflow-hidden pt-2"
              >
                <span className="target-text inline-block leading-tight opacity-0">
                  {word.trim()}{' '}
                </span>
              </span>
            ))
          : content.map((sentence, index) => {
              return (
                <Fragment key={index}>
                  <span className="inline-block overflow-hidden">
                    {sentence.split(' ').map((word, i) => (
                      <span
                        key={i}
                        className="mr-[0.5ch] inline-flex overflow-hidden leading-tight"
                      >
                        <span
                          className={clsx(
                            'target-text inline-flex leading-tight opacity-0',
                            splittedClassNames?.[index]
                          )}
                        >
                          {word.trim()}
                        </span>
                      </span>
                    ))}
                  </span>
                  <br />
                </Fragment>
              )
            })}
      </Text>
    </div>
  )
}

export default AnimatedText
